(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tg-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tg-announcement-countdown')) {
  customElements.define('tg-announcement-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      const duration = Number(this.dataset.duration);
      const campaignDeadline = Date.parse(this.dataset.endsAt || '');
      if (!Number.isFinite(campaignDeadline) && (!Number.isFinite(duration) || duration <= 0)) return;
      if (Number.isFinite(campaignDeadline)) {
        this.deadline = campaignDeadline;
      } else if (this.deadline === undefined) {
        const storageKey = `tsuki:announcement-countdown:v1:${this.dataset.countdownKey || 'announcement'}:${duration}`;
        let storedDeadline = 0;
        try { storedDeadline = Number(sessionStorage.getItem(storageKey)); } catch {}
        this.deadline = Number.isSafeInteger(storedDeadline) && storedDeadline > 0 ? storedDeadline : Date.now() + duration * 1000;
        try { sessionStorage.setItem(storageKey, String(this.deadline)); } catch {}
      }
      const parts = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-countdown-${unit}]`));
      const update = () => {
        if (document.hidden) return;
        const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        parts.forEach((element, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (element.textContent !== value) element.textContent = value;
        });
        if (remaining === 0) { clearInterval(this.interval); this.interval = null; }
      };
      this.interval = setInterval(update, 1000);
      update();
      this.hidden = false;
      this.controller = new AbortController();
      document.addEventListener('visibilitychange', update, {signal: this.controller.signal});
      window.addEventListener('pageshow', update, {signal: this.controller.signal});
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-featured-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tg-more-products'))customElements.define('tg-more-products',class extends HTMLElement{
 connectedCallback(){if(this.controller)return;this.controller=new AbortController();this.cards=[...this.querySelectorAll('[data-inline-product]')];this.buttons=[...this.querySelectorAll('[data-more-products]')];this.update();this.addEventListener('click',event=>{if(!event.target.closest('[data-more-products]'))return;const next=this.cards.filter(card=>card.hidden).slice(0,Number(this.dataset.step));next.forEach(card=>card.hidden=false);this.update();const link=next[0]?.querySelector('a');link?.focus({preventScroll:true});next[0]?.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})},{signal:this.controller.signal})}
 update(){const count=this.cards.filter(card=>!card.hidden).length;this.buttons.forEach(button=>button.hidden=count===this.cards.length);this.querySelector('[data-products-status]').textContent=this.dataset.statusTemplate.replace('__COUNT__',count).replace('__TOTAL__',this.cards.length)}
 disconnectedCallback(){this.controller?.abort();this.controller=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-header"]) return;
  try {
    
// Show on scroll up, like the previous live theme (Dawn "on-scroll-up"): once the page scrolls past the header it
// hides while scrolling down and slides back in on scroll up; at the top it sits in place again. It moves with
// `top`, not a transform, so the fixed mobile menu inside it keeps working.
(() => {
  const wrap = document.querySelector('.tg-header')?.closest('.shopify-section');
  if (!wrap) return;
  wrap.classList.add('tg-header-section');
  let bounds = {top: 0, bottom: 0};
  let last = window.scrollY;
  let frame = 0;
  const measure = () => {
    if (wrap.classList.contains('is-sticky')) return;
    const rect = wrap.getBoundingClientRect();
    bounds = {top: rect.top + window.scrollY, bottom: rect.bottom + window.scrollY};
    document.documentElement.style.setProperty('--tg-header-height', rect.height + 'px');
  };
  const update = () => {
    frame = 0;
    const y = window.scrollY;
    if (document.documentElement.classList.contains('tg-menu-locked')) { last = y; return; }
    if (y > last && y > bounds.bottom) {
      wrap.classList.add('is-sticky', 'is-hidden');
      wrap.querySelectorAll('[data-menu][open]').forEach(menu => { menu.open = false; });
    } else if (y < last && y > bounds.bottom) {
      wrap.classList.add('is-sticky', 'is-animate');
      wrap.classList.remove('is-hidden');
    } else if (y <= bounds.top) {
      wrap.classList.remove('is-sticky', 'is-hidden', 'is-animate');
    }
    last = y;
  };
  measure();
  window.addEventListener('resize', measure, {passive: true});
  window.addEventListener('load', measure, {once: true});
  window.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive: true});
})();
(() => {
  const mobile = window.matchMedia('(max-width: 900px)');
  let drawer = null;
  const lock = value => {
    document.documentElement.classList.toggle('tg-menu-locked', value);
    document.body.classList.toggle('tg-menu-locked', value);
  };
  const focusable = panel => [...panel.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
  const sync = (menu, moveFocus = false) => {
    const summary = menu.querySelector(':scope > summary');
    summary?.setAttribute('aria-expanded', String(menu.open));
    const panel = menu.querySelector('.tg-nav__panel');
    if (!panel) return;
    if (menu.open && mobile.matches) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      drawer = menu;
      lock(true);
      if (moveFocus) {
        (focusable(panel)[0] || panel).focus();
        panel.scrollTop = 0;
      }
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      if (drawer === menu) { drawer = null; lock(false); }
    }
  };
  const close = (menu, restoreFocus = false) => {
    menu.open = false;
    sync(menu);
    if (restoreFocus) menu.querySelector(':scope > summary')?.focus();
  };
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!(menu instanceof HTMLElement) || !menu.matches('.tg-header [data-menu]')) return;
    if (menu.open) document.querySelectorAll('.tg-header [data-menu][open]').forEach(other => { if (other !== menu) close(other); });
    sync(menu, menu.open && menu.matches('.tg-nav'));
  }, true);
  document.addEventListener('click', event => {
    const closeButton = event.target.closest('[data-menu-close]');
    if (closeButton) { close(closeButton.closest('.tg-nav'), true); return; }
    document.querySelectorAll('.tg-header [data-menu][open]').forEach(menu => {
      if (!menu.contains(event.target)) close(menu);
      else if (menu.matches('.tg-nav') && event.target.closest('a[href]')) close(menu);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menus = document.querySelectorAll('.tg-header [data-menu][open]');
      if (menus.length) { event.preventDefault(); menus.forEach(menu => close(menu, true)); }
      return;
    }
    if (event.key !== 'Tab' || !drawer?.open || !mobile.matches) return;
    const panel = drawer.querySelector('.tg-nav__panel');
    const items = focusable(panel);
    const first = items[0] || panel, last = items[items.length - 1] || panel;
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('focusin', event => {
    if (!drawer?.open || !mobile.matches) return;
    const panel = drawer.querySelector('.tg-nav__panel');
    if (!panel.contains(event.target)) (focusable(panel)[0] || panel).focus();
  });
  mobile.addEventListener('change', () => document.querySelectorAll('.tg-header [data-menu][open]').forEach(menu => close(menu, true)));
  document.addEventListener('shopify:section:unload', event => {
    if (drawer && event.target.contains(drawer)) { drawer = null; lock(false); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-home-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tg-review-carousel')) {
  customElements.define('tg-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.review-list');
      if (!this.track) return;
      this.previous = this.querySelector('[data-review-step="-1"]');
      this.next = this.querySelector('[data-review-step="1"]');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const update = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = this.track.querySelector('.review-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
        this.track.scrollBy({left: direction * step, behavior: this.motion()});
      };
      this.previous.addEventListener('click', () => move(-1), {signal});
      this.next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', update, {passive: true, signal});
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion()});
        }
      }, {signal});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.track);
      update();
    }
    motion() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-product"]) return;
  try {
    
if(!customElements.get('tg-product'))customElements.define('tg-product',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.addEventListener('change',event=>{if(event.target.matches('.tg-variants input[name=id]'))this.selectVariant(event.target);if(event.target.name==='quantity')this.syncQuantity()});
  this.addEventListener('click',event=>{
   const thumb=event.target.closest('[data-media-target]');if(thumb){event.preventDefault();this.selectMedia(thumb.dataset.mediaTarget)}
   const stepper=event.target.closest('[data-quantity-step]');if(stepper){const qty=this.querySelector('.tg-buy-row [name=quantity]');Number(stepper.dataset.quantityStep)>0?qty.stepUp():qty.stepDown();qty.dispatchEvent(new Event('change',{bubbles:true}))}
   const arrow=event.target.closest('[data-ritual-step]');if(arrow){const track=this.querySelector('.tg-ritual-track');const cards=[...track.children];const current=cards.findIndex(card=>!card.hidden);const next=(current+Number(arrow.dataset.ritualStep)+cards.length)%cards.length;cards.forEach((card,index)=>card.hidden=index!==next)}
  });
  const headings=[...this.querySelectorAll('.tg-product-shell--storm .tg-variant__name > strong')];
  const alignHeading=heading=>{if(!heading.isConnected)return;const lineHeight=parseFloat(getComputedStyle(heading).lineHeight);heading.closest('.tg-variant').classList.toggle('tg-variant--single-line',heading.getBoundingClientRect().height<lineHeight*1.5)};
  this.bundleResize=new ResizeObserver(entries=>entries.forEach(entry=>alignHeading(entry.target)));
  headings.forEach(heading=>{alignHeading(heading);this.bundleResize.observe(heading)});
  document.fonts.ready.then(()=>headings.forEach(alignHeading));
  this.setupGallery();
  const selected=this.querySelector('.tg-variants input[name=id]:checked');const initial=selected?.dataset.media||this.querySelector('[data-media-id]')?.dataset.mediaId;if(initial&&!location.hash.startsWith('#GalleryMedia-'))this.selectMedia(initial,'instant');this.syncQuantity();if(selected)this.syncPaymentTerms(selected.value);
 }
 disconnectedCallback(){this.bundleResize?.disconnect();this.galleryResize?.disconnect();this.galleryEvents?.abort();cancelAnimationFrame(this.galleryFrame);clearTimeout(this.galleryWheelTimer);clearTimeout(this.galleryClickTimer);this.ready=false;}
 syncQuantity(){const qty=this.querySelector('.tg-buy-row [name=quantity]');const down=this.querySelector('[data-quantity-step="-1"]');const up=this.querySelector('[data-quantity-step="1"]');if(!down||!up)return;down.disabled=Number(qty.value)<=Number(qty.min||1);up.disabled=!!qty.max&&Number(qty.value)>=Number(qty.max);}
 setupGallery(){
  if(this.querySelector('tg-product-gallery'))return;
  this.galleryStage=this.querySelector('.tg-gallery__stage');
  this.galleryPanels=[...this.querySelectorAll('[data-media-id]')];
  this.galleryThumbs=this.querySelector('.tg-gallery__thumbs');
  this.galleryIndex=0;
  this.galleryEvents=new AbortController();
  const signal=this.galleryEvents.signal;
  const gallery=this.querySelector('[data-gallery]');
  this.galleryStage.addEventListener('scroll',()=>{
   cancelAnimationFrame(this.galleryFrame);
   this.galleryFrame=requestAnimationFrame(()=>this.syncGallery(Math.round(this.galleryStage.scrollLeft/this.galleryStage.clientWidth)));
  },{passive:true,signal});
  gallery.addEventListener('keydown',event=>{
   if(event.target!==this.galleryStage&&!event.target.matches('[data-media-target]'))return;
   const index=event.target.matches('[data-media-target]')?[...this.galleryThumbs.children].indexOf(event.target):this.galleryIndex;
   const next={ArrowLeft:index-1,ArrowRight:index+1,Home:0,End:this.galleryPanels.length-1}[event.key];
   if(next===undefined)return;
   event.preventDefault();
   const panel=this.galleryPanels[Math.max(0,Math.min(next,this.galleryPanels.length-1))];
   if(!panel)return;
   this.selectMedia(panel.dataset.mediaId);
   if(event.target!==this.galleryStage)this.galleryThumbs.querySelector('[data-media-target="'+panel.dataset.mediaId+'"]').focus({preventScroll:true});
  },{signal});
  gallery.addEventListener('dragstart',event=>{if(event.target.tagName==='IMG')event.preventDefault()},{signal});
  gallery.addEventListener('click',event=>{if(this.galleryDragged){event.preventDefault();event.stopPropagation();this.galleryDragged=false}},{capture:true,signal});
  [this.galleryStage,this.galleryThumbs].filter(Boolean).forEach(track=>{
   let drag;
   track.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('video,iframe,model-viewer'))return;
    this.galleryDragged=false;
    drag={id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,active:false};
   },{signal});
   track.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.id)return;
    if((event.buttons&1)!==1){drag=null;return}
    const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
    if(!drag.active){
     if(Math.abs(dx)<6||Math.abs(dx)<=Math.abs(dy))return;
     drag.active=true;track.setPointerCapture(event.pointerId);track.style.scrollSnapType='none';track.classList.add('is-dragging');
    }
    event.preventDefault();track.scrollLeft=drag.left-dx;
   },{signal});
   const finish=()=>{
    if(!drag)return;
    const active=drag.active;drag=null;
    track.style.scrollSnapType='';track.classList.remove('is-dragging');
    if(active){this.galleryDragged=true;clearTimeout(this.galleryClickTimer);this.galleryClickTimer=setTimeout(()=>{this.galleryDragged=false},0);if(track===this.galleryStage){const index=Math.round(track.scrollLeft/track.clientWidth);this.selectMedia(this.galleryPanels[index]?.dataset.mediaId)}}
   };
   track.addEventListener('pointerup',finish,{signal});
   track.addEventListener('pointercancel',finish,{signal});
   track.addEventListener('lostpointercapture',finish,{signal});
  });
  this.galleryThumbs?.addEventListener('wheel',event=>{
   if(event.ctrlKey||Math.abs(event.deltaX)>=Math.abs(event.deltaY))return;
   const track=this.galleryThumbs;
   const delta=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?track.clientWidth:1);
   const next=Math.max(0,Math.min(track.scrollLeft+delta,track.scrollWidth-track.clientWidth));
   if(Math.abs(next-track.scrollLeft)<1)return;
   event.preventDefault();track.style.scrollSnapType='none';track.scrollLeft=next;
   clearTimeout(this.galleryWheelTimer);this.galleryWheelTimer=setTimeout(()=>{track.style.scrollSnapType=''},150);
  },{passive:false,signal});
  this.galleryResize=new ResizeObserver(()=>this.galleryStage.scrollTo({left:this.galleryIndex*this.galleryStage.clientWidth,behavior:'instant'}));
  this.galleryResize.observe(this.galleryStage);
 }
 syncGallery(index){
  const target=this.galleryPanels[index];if(!target)return;
  this.galleryIndex=index;
  this.galleryPanels.forEach(panel=>{const active=panel===target;panel.inert=!active;panel.setAttribute('aria-hidden',String(!active));if(!active)panel.querySelectorAll('video').forEach(video=>video.pause())});
  this.galleryThumbs?.querySelectorAll('[data-media-target]').forEach(link=>{
   const active=link.dataset.mediaTarget===target.dataset.mediaId;
   link.setAttribute('aria-current',String(active));
   if(active){const rail=this.galleryThumbs,box=link.getBoundingClientRect(),bounds=rail.getBoundingClientRect();if(box.left<bounds.left)rail.scrollLeft+=box.left-bounds.left;else if(box.right>bounds.right)rail.scrollLeft+=box.right-bounds.right;}
  });
 }
 selectMedia(id,behavior='smooth'){
  const sharedGallery=this.querySelector('tg-product-gallery');
  if(sharedGallery){if(sharedGallery.selectMedia)sharedGallery.selectMedia(id,behavior);else customElements.whenDefined('tg-product-gallery').then(()=>{if(this.isConnected)sharedGallery.selectMedia(id,behavior)});return;}
  const index=this.galleryPanels?.findIndex(panel=>panel.dataset.mediaId===id);if(index===undefined||index<0)return;
  this.syncGallery(index);
  this.galleryStage.scrollTo({left:index*this.galleryStage.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':behavior});
 }
 syncPaymentTerms(id){this.querySelectorAll('shopify-payment-terms').forEach(terms=>terms.setAttribute('variant-id',id))}
 selectVariant(input){
  this.syncPaymentTerms(input.value);
  this.querySelectorAll('[data-bundle-gift-panel]').forEach(panel=>{panel.hidden=panel.dataset.bundleGiftPanel!==input.value;});
  this.querySelectorAll('.tg-variant').forEach(label=>{const selected=label.contains(input);label.classList.toggle('is-selected',selected);const details=label.querySelector('.tg-package-details');if(details)details.hidden=!selected;});
  this.querySelector('[data-product-price]').textContent=input.dataset.price;
  this.querySelector('[data-product-compare]').hidden=!input.dataset.compare;
  this.querySelector('[data-compare-value]').textContent=input.dataset.compare;
  this.querySelector('[data-product-sale]').hidden=!input.dataset.compare;this.querySelector('[data-product-sale]').textContent=input.dataset.sale;
  const qty=this.querySelector('.tg-buy-row [name=quantity]');qty.min=input.dataset.min||'1';qty.step=input.dataset.step||'1';if(input.dataset.max)qty.max=input.dataset.max;else qty.removeAttribute('max');qty.value=qty.min;this.syncQuantity();
  const add=this.querySelector('.tg-buy-row [name=add]');add.disabled=input.dataset.available!=='true';add.querySelector('[data-add-copy]').textContent=add.disabled?add.dataset.soldLabel:add.dataset.addLabel;
  const amount=add.querySelector('[data-add-price]');if(amount){amount.hidden=add.disabled;amount.textContent=' · '+input.dataset.price;}
  const stock=this.querySelector('[data-stock-copy]');if(stock){stock.textContent=add.disabled?stock.dataset.unavailable:stock.dataset.ready;this.querySelector('[data-stock-dot]').hidden=add.disabled;}
  const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);if(input.dataset.media&&!this.classList.contains('tg-product-shell--storm'))this.selectMedia(input.dataset.media);
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-storm-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tg-review-carousel')) {
  customElements.define('tg-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.review-list');
      if (!this.track) return;
      this.previous = this.querySelector('[data-review-step="-1"]');
      this.next = this.querySelector('[data-review-step="1"]');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const update = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      const move = (direction) => {
        const card = this.track.querySelector('.review-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).gap) || 0);
        this.track.scrollBy({left: direction * step, behavior: this.motion()});
      };
      this.previous.addEventListener('click', () => move(-1), {signal});
      this.next.addEventListener('click', () => move(1), {signal});
      this.track.addEventListener('scroll', update, {passive: true, signal});
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion()});
        }
      }, {signal});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.track);
      update();
    }
    motion() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
